<template>
	<div class="container">
		<div class="help">
			<div class="help-body">
				<div class="help-title">发布规则 Publishing Rule</div>
				<div class="help-content">
					<div class="help-c-view">
						<p>感谢您使用播聘！</p>
						<p>本《播聘职位信息发布规则》（以下简称“本规则”）系由您与播聘网络技术（深圳）有限公司（以下简称“播聘”）订立的《播聘聘用户协议》的有效组成部分， 与《播聘用户协议》共同构成您与播聘合作的法律文件。 您在注册、使用播聘软件发布职位信息之前，请务必审慎阅读、充分理解本规则。 您使用播聘软件职位信息服务的行为，即表示您已阅读并同意本规则所涉全部内容。</p>
						<br>
						<p>播聘有权根据法律法规、政策及产品需求更新本规则，并通过软件发布更新版本的方式修改本规则，修改后的规则于发布时生效。请您定期访问并查看最新规则。如您继续使用播聘服务的，即表示您接受经修订后的规则。</p>
						<br>
						<p>1.播聘为用户提供发布职位招聘信息的免费服务和增值服务。用户使用播聘APP应当遵守本规则以及其他与播聘签署的协议。</p>
						<br>
						<p>2.播聘有权对不同的职位类别下职位信息设置不同的有效期，有效期届满时该职位信息可能被下线。</p>
						<br>
						<p>3.播聘有权对用户发布的职位信息进行审核，对于不符合本规则的内容，有权拒绝发布或者删除。</p>
						<br>
						<p>4.用户不得发布包含下列内容的职位信息或其他信息：</p>
						<p>(1) 包含广告（寻求合作）、传销、直销等内容</p>
						<p>(2) 包含色情、淫秽内容</p>
						<p>(3) 包含违法、政治敏感内容</p>
						<p>(4) 包含不真实的公司信息</p>
						<p>(5) 包含虚假的人员身份信息</p>
						<p>(6) 包含不真实的薪资、工作地点，或者工作地点不在中国境内的</p>
						<p>(7) 包含不真实的职位描述、工作内容</p>
						<p>(8) 职位类型与职位描述不符的</p>
						<p>(9) 一个岗位发布多个职位</p>
						<p>(10) 职位名称与职位描述不明确的</p>
						<p>(11) 职位名称包含职位名称以外信息的</p>
						<p>(12) 涉及违反《劳动合同法》</p>
						<p>(13) 包含性别歧视或指向性歧视，如地域歧视的内容</p>
						<p>(14) 包含人身攻击或其他侵害他人权益的内容</p>
						<p>(15) 信用卡套现、售卖POS机、二维码支付类职位</p>
						<p>(16) 淘宝刷单、微商代理、手机兼职、手工兼职类职位</p>
						<p>(17) 多个相同职位</p>
						<p>(18) 游戏代练类职位</p>
						<p>(19) 被多位用户举报</p>
						<p>(20) 涉及发布代孕、捐精、捐卵业务</p>
						<p>(21) 挂靠类职位</p>
						<p>(22) 发布的职位信息与实际所招聘职位不符</p>
						<p>(23) 其他（鸡汤、段子、水贴等）</p>
						<p>用户发布的职位信息或其他信息包含但不限于上述内容的，经播聘发现或用户投诉后核实的，播聘有权驳回其职位发布申请、删除职位信息。</p>
						<br>
						<p>5.播聘不为下述公司提供职位发布服务，因此如使用播聘服务的用户服务于下述公司的，播聘有权删除其发布的职位信息：</p>
						<p>(1) 存在猎头业务的公司</p>
						<p>(2) 存在招聘流程外包即RPO业务的公司</p>
						<p>(3) 存在招聘业务的公司</p>
						<p>(4) 所招聘岗位无薪资或涉及拒发或恶意拖欠工资的公司</p>
						<p>(5) 涉及以招聘名义招人培训的公司</p>
						<p>(6) 存在淘宝刷单、微商代理、手机兼职、手工兼职业务的公司</p>
						<p>(7) 涉及收取求职者费用的公司</p>
						<p>(8) 存在直销或传销模式业务的公司</p>
						<p>(9) 存在信用卡套现、售卖POS机、二维码支付业务的公司</p>
						<p>(10) 在国家企业信用信息公示系统中被列入经营异常名录的公司</p>
						<p>(11) 在国家企业信用信息公示系统中的登记状态为注销/吊销状态的公司</p>
						<p>(12) 已被法院判定为破产或正在进行破产申请流程的公司</p>
						<p>(13) 在第三方网站中查询到存在严重失信行为的公司</p>
						<p>(14) 在国家企业信用信息公示系统中查询不到注册信息的公司</p>
						<p>(15) 被多位用户举报的公司</p>
						<p>(16) 涉及发布代孕、捐精、捐卵的业务</p>
						<p>(17) 存在兼职主播业务的公司</p>
						<p>(18) 存在挂靠业务的公司</p>
						<br>
						<p>6.播聘严禁用户利用播聘服务，实施下述行为：</p>
						<p>(1) 以培训费、服装费、工作需要等任何名义骗取求职者财物或涉及收取求职者费用、要求求职者贷款</p>
						<p>(2) 实施传销活动或骗取他人加入传销组织</p>
						<p>(3) 招聘他人从事违法活动</p>
						<p>(4) 向求职者或其他用户索取个人信息、隐私内容</p>
						<p>(5) 骚扰其他用户</p>
						<p>(6) 利用平台可能存在的漏洞恶意充值“直豆”、获取“彩虹卡”等道具产品</p>
						<p>(7) 在第三方售卖“直豆”、“彩虹卡”等道具产品</p>
						<p>(8) 存在辱党、辱国、传播邪教思想的行为</p>
						<p>(9) 存在使用涉及各国政治人物的图片</p>
						<p>(10) 存在使用含色情、淫秽内容的图片</p>
						<p>(11) 存在使用人身攻击或其他侵害他人权益的图片</p>
						<p>(12) 存在使用广告（寻求合作）的头像</p>
						<p>(13) 存在帮其他公司招聘或猎头、RPO的行为</p>
						<p>(14) 以招聘名义招人培训</p>
						<p>(15) 所招聘岗位无薪资或存在涉及拒发或恶意拖欠工资的行为</p>
						<p>(16) 招聘未满16周岁人员</p>
						<p>(17) 其他关联账号存在违规行为</p>
						<p>(18) 其他违反法律规定的行为</p>
						<p>用户实施上述行为，经播聘发现或用户投诉后核实的，播聘有权立即停止对该用户提供服务、删除用户发布的职位信息。</p>
						<br>
						<p>7.若用户违反前述第4条、第5条、第6条规定的内容，或者有其他明显损害播聘利益或违法行为的，播聘有权视情节采取冻结用户账户的方式暂时乃至永久停止其使用播聘服务且不做解封与退款处理。 如用户行为涉嫌违法犯罪的，播聘有权向有关行政机关及司法部门举报、披露相关信息。</p>
						<br>
						<p>8.用户违反本规则的，播聘可以依据本规则直接采取相关措施，并视情节严重程度选择是否通知用户。接到通知的用户可以通过客户服务渠道向播聘提交申诉。</p>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: `ShowHelp`
	}
</script>

<style scoped="scoped">
	@import url("./show-help.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-help/show-help.vue